export enum ViewInclude {
    CONFIG = 'config',
    SHARES = 'shares',
    FORM = 'form',
    DATA = 'data',
    FILTERS = 'filters',
}
